'use client'

import * as React from 'react'
import { InfiniteCarousel } from '../infinite-carousel'
import { SeedanceVideoItem } from './seedance-video-item'
import { tw } from 'utils/classnames'

const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL ?? ''
const VIDEO_BASE = `${LFS_URL}/studio/video/seedance-2-0/videos`

const SHOWCASE_CLIPS = [
  '1.webm',
  '2.webm',
  '3.webm',
  '4.webm',
  '5.webm',
  '6.webm',
  '7.webm',
  '8.webm',
  '9.webm',
] as const

interface SeedanceStripProps {
  title: string
  tryItLabel: string
  scrollLeftLabel: string
  scrollRightLabel: string
  className?: string
}

export function SeedanceStrip({
  title,
  tryItLabel,
  scrollLeftLabel,
  scrollRightLabel,
  className = '',
}: SeedanceStripProps) {
  const loopedClips = React.useMemo(
    () => [...SHOWCASE_CLIPS, ...SHOWCASE_CLIPS, ...SHOWCASE_CLIPS],
    [],
  )

  return (
    <section className={tw('flex flex-col gap-2', className)}>
      <h2 className="text-base font-semibold font-poppins text-cf-black">{title}</h2>
      <InfiniteCarousel
        itemCount={SHOWCASE_CLIPS.length}
        scrollLeftLabel={scrollLeftLabel}
        scrollRightLabel={scrollRightLabel}
      >
        {loopedClips.map((clip, index) => {
          const setIndex = Math.floor(index / SHOWCASE_CLIPS.length)
          return (
            <SeedanceVideoItem
              key={`${clip}-${setIndex}`}
              data-card
              src={`${VIDEO_BASE}/${clip}`}
              tryItLabel={tryItLabel}
            />
          )
        })}
      </InfiniteCarousel>
    </section>
  )
}
